import React, { ReactNode, useState } from 'react'

import { useField, useFormikContext } from 'formik'

import CheckboxGroup from '../components/CheckboxGroup'
import Label from '../components/Label'
import FieldProps from './FieldProps'
import Error from './FormItemError'

interface CheckboxGroupProps extends FieldProps {
  options?: string[]
  value?: any[]
  disabled?: boolean
  defaultValue?: string[] | number[]
  children: ReactNode
}

const FormikCheckboxGroupField: React.FC<CheckboxGroupProps> = ({ label, value, defaultValue, ...props }) => {
  const [field, meta] = useField({ ...props })
  const showError = meta.touched && meta.error

  let selectedValues: any[] = value ? value : []
  let { setFieldValue } = useFormikContext()

  const [selected, setSelected] = useState(selectedValues)

  const onChange = (checkedValues: any[]) => {
    selectedValues.push(...checkedValues)
    setSelected(selectedValues)
    setFieldValue(props.name, selectedValues)
  }

  return (
    <>
      <Label htmlFor={props.id || props.name}>{label}</Label>
      {selected && (
        <CheckboxGroup {...props} value={field.value} onChange={onChange}>
          {props.children}
        </CheckboxGroup>
      )}
      {showError && <Error>{meta.error}</Error>}
    </>
  )
}
export { FormikCheckboxGroupField as CheckboxGroup }
export default FormikCheckboxGroupField
